<template>
  <div class="json-tree"></div>
</template>
<script>
import JSONEditor from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.css';

export default {
  props: {
    value: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ed: null
    };
  },
  mounted() {
    this.ed = new JSONEditor(this.$el, {
      mode: this.readOnly ? 'view' : 'tree',
      mainMenuBar: false,
      statusBar: false,
      navigationBar: false,
      enableSort: false,
      enableTransform: false,
      onEditable: node => {
        // Only allow editing the value of 'description' fields
        if (this.readOnly) {
          return { field: false, value: false };
        }
        // Allow editing value only (not field name) of description properties
        if (node.field === 'description') {
          return { field: false, value: true };
        }
        return { field: false, value: false };
      },
      onCreateMenu: (items, node) => {
        // Return empty array to disable context menu
        return [];
      }
    });
    this.ed.set(this.value);
  },
  beforeDestroy() {
    if (this.ed) {
      this.ed.destroy();
    }
  },
  methods: {
    getValue() {
      return this.ed ? this.ed.get() : this.value;
    }
  }
};
</script>

<style scoped>
.json-tree {
  height: 100%;
  width: 100%;
  overflow-y: auto;
}
</style>

<style>
div.jsoneditor,
div.jsoneditor-menu {
  border: 1px solid var(--theme-on-background-dark);
  border-radius: 2px;
}
div.jsoneditor-menu {
  background-color: var(--theme-background);
}
div.jsoneditor-tree,
div.jsoneditor textarea.jsoneditor-text {
  color: var(--theme-on-background);
  background: var(--theme-background);
}
div.jsoneditor-field,
div.jsoneditor-value {
  color: var(--theme-on-background);
}

/* Make editable description values visually distinct */
div.jsoneditor-value[contenteditable='true'] {
  background-color: var(--theme-surface);
  border: 1px dashed var(--theme-primary);
  padding: 4px 6px;
  border-radius: 2px;
  cursor: text;
  color: var(--theme-on-background);
}

tr.jsoneditor-highlight,
tr.jsoneditor-selected {
  background-color: var(--theme-highlight);
}

div.jsoneditor-field[contenteditable='true']:focus,
div.jsoneditor-field[contenteditable='true']:hover,
div.jsoneditor-value[contenteditable='true']:focus,
div.jsoneditor-value[contenteditable='true']:hover,
div.jsoneditor-field.jsoneditor-highlight,
div.jsoneditor-value.jsoneditor-highlight {
  background-color: var(--theme-surface);
  border-color: var(--theme-primary);
}

div.jsoneditor-field.highlight-active,
div.jsoneditor-field.highlight-active:focus,
div.jsoneditor-field.highlight-active:hover,
div.jsoneditor-value.highlight-active,
div.jsoneditor-value.highlight-active:focus,
div.jsoneditor-value.highlight-active:hover {
  background-color: var(--theme-surface);
  border-color: var(--theme-primary);
}

div.jsoneditor-tree button:focus,
div.jsoneditor-tree button.jsoneditor-button:focus {
  background-color: var(--theme-highlight);
  border-color: transparent;
  outline: none;
}

div.jsoneditor-readonly {
  color: var(--theme-on-background);
}

div.jsoneditor div.jsoneditor-tree {
  color: var(--theme-on-surface);
}

div.jsoneditor-tree div.jsoneditor-show-more {
  color: var(--theme-primary);
}
div.jsoneditor-tree div.jsoneditor-show-more a:hover,
div.jsoneditor-tree div.jsoneditor-show-more a:focus {
  color: var(--theme-primary);
}

/* Hide drag area to prevent reordering */
div.jsoneditor-tree button.jsoneditor-dragarea {
  display: none !important;
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* Hide context menu icon */
div.jsoneditor-tree button.jsoneditor-contextmenu-button {
  display: none !important;
  width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
}
</style>
